/**
 * mcycle empty product module
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2018/01/02
 */
import './index.css';
import React from 'react';
import { Link } from 'react-router-dom';

const Empty = ({ isEmpty, isHome, query }) => {
  return <div className="mcycle-product-empty" style={{display: isEmpty ? 'block': 'none'}}>
    <div className="mcycle-product-empty-text">
      <p style={{display: isEmpty && isHome ? 'block': 'none'}}>没有找到相关产品</p>

      <div style={{display: isEmpty && !isHome ? 'block': 'none'}}>
        <p>没有找到 "{query}" 机型</p>
        <p>请检查输入机型是否有误</p>
        <Link className="mcycle-back-home" to={{ pathname: '/' }}>返回首页</Link>
      </div>
    </div>
  </div>
}

export default Empty



// WEBPACK FOOTER //
// ./src/components/home/productList/empty/index.js